import { fetchApiData, PIC } from '../templates/Internals';
export class GlobUserConfig {
    get dateLang() { return this.dateLang_ ? this.dateLang_ : this.userLang; }
    get currencyLang() { return this.currencyLang_ ? this.currencyLang_ : this.userLang; }
    get numberLang() { return this.numberLang_ ? this.numberLang_ : this.userLang; }
    get minMaxDigits() { return this.minMaxDigits_; }
    ;
    get dateOptions() { return this.dateOptions_; }
    ;
    get timeOptions() { return this.timeOptions_; }
    ;
    get dateTimeFormat() { return this.dateTimeFormat_; }
    ;
    set dateTimeFormat(iFormat) { this.dateTimeFormat_ = iFormat; this.setData(); }
    ;
    get dateFormat() { return this.dateFormat_; }
    ;
    set dateFormat(iFormat) { this.dateFormat_ = iFormat; this.setData(); }
    ;
    get timeFormat() { return this.timeFormat_; }
    ;
    set timeFormat(iFormat) { this.timeFormat_ = iFormat; this.setData(); }
    ;
    get dateTimeOptions() { return Object.assign(Object.assign({}, this.dateOptions_), this.timeOptions_); }
    ;
    get currency() { return this.currency_; }
    ;
    get isNavDrawerPinned() { return this.isNavDrawerPinned_; }
    ;
    set isNavDrawerPinned(iPin) {
        this.isNavDrawerPinned_ = iPin;
        this.setData();
    }
    ;
    get sendError() { return this.sendError_; }
    set sendError(iSend) {
        this.sendError_ = iSend;
        this.setData();
    }
    ;
    get theme() { return this.theme_; }
    ;
    set theme(iTheme) {
        this.theme_ = iTheme;
        this.applyTheme();
        this.setData();
    }
    ;
    //Public because every doSubmit does document.write(), which builds a fresh <html> and
    //drops data-theme, while this instance survives on window.PIC - so the swap re-applies it.
    applyTheme() {
        document.documentElement.setAttribute('data-theme', this.theme_);
        //Mirrored to localStorage 
        //Written directly because this class
        //is constructed from inside PIC's own constructor, before window.PIC is
        //assigned - going through PIC.getInstance here recurses infinitely.
        localStorage.setItem('picTheme', this.theme_);
    }
    constructor() {
        this.theme_ = 'light';
        this.hasData_ = false;
        //Default values
        this.userLang = 'en-GB';
        this.dateLang_ = 'da-DK';
        this.dateOptions_ = { year: 'numeric', month: '2-digit', day: '2-digit' };
        this.timeOptions_ = { hour: '2-digit', minute: '2-digit', second: '2-digit' };
        this.dateTimeFormat_ = 'YYYY-MM-dd HH:mm:ss';
        this.dateFormat_ = 'YYYY-MM-dd';
        this.timeFormat_ = 'HH:mm:ss';
        this.currencyLang_ = '';
        this.currency_ = 'DKK';
        this.numberLang_ = '';
        this.minMaxDigits_ = { min: 2, max: 2 };
        this.isNavDrawerPinned_ = false;
        this.options_ = {
            // sessionId: PIC.sessionCode,
            systemId: PIC.systemId,
            postBody: {}
        };
        //Seed from the localStorage mirror so the theme is right on first paint, before
        //(or without) an incl/settings call - pages with no nav drawer never make one.
        let savedTheme = localStorage.getItem('picTheme');
        if (savedTheme === 'light' || savedTheme === 'dark')
            this.theme_ = savedTheme;
        this.applyTheme();
    }
    calcHour(iTime) {
        let hours = Math.floor(iTime / 3600);
        return String(hours);
    }
    calcMin(iTime) {
        let hours = Math.floor(iTime / 3600);
        let minutes = Math.floor((iTime - (hours * 3600)) / 60);
        return String(minutes);
    }
    calcSec(iTime) {
        let hours = Math.floor(iTime / 3600);
        let minutes = Math.floor((iTime - (hours * 3600)) / 60);
        let seconds = iTime - (hours * 3600) - (minutes * 60);
        return String(seconds);
    }
    formatTime(iTime) {
        let retVal = '';
        // let seconds, minutes, hours = Math.floor(iTime / 3600);
        // let secondString = '', minuteString = '', hourString = '';
        // if('hour' in this.timeOptions){
        //     if(this.timeOptions.hour == '2-digit') {
        //         hourString = String(hours).padStart(2, '0');
        //     } else {
        //         hourString = String(hours);
        //     }
        //     retVal = hourString;
        // } 
        // if('minute' in this.timeOptions){
        //     minutes = Math.floor((iTime - (hours * 3600)) / 60);    
        //     if(this.timeOptions.minute == '2-digit'){
        //         minuteString = String(minutes).padStart(2, '0');
        //     } else {
        //         minuteString = String(minutes);
        //     }
        //     retVal = retVal + ':' + minuteString;
        // } 
        // if('second' in this.timeOptions){
        //     minutes = Math.floor((iTime - (hours * 3600)) / 60);
        //     seconds = iTime - (hours * 3600) - (minutes * 60);
        //     if(this.timeOptions.minute == '2-digit'){
        //         secondString = String(seconds).padStart(2, '0');
        //     } else {
        //         secondString = String(seconds);
        //     }
        //     retVal = retVal + ':' + secondString;
        // }
        let today = new Date();
        let time = new Date(today.getFullYear(), today.getMonth(), today.getDate(), Number(this.calcHour(iTime)), Number(this.calcMin(iTime)), Number(this.calcSec(iTime)));
        retVal = this.translateDate(time, this.timeFormat_);
        return retVal;
    }
    date2Format(iDate, iFormat) {
        let then = new Date(iDate.getFullYear(), iDate.getMonth(), iDate.getDate(), 0, 0, 0);
        let mtime = (iDate.getTime() - then.getTime()) / 1000;
        switch (iFormat) {
            /* Date */
            case 'G': /* Era */ return iDate.getFullYear() > 0 ? "AD" : "BC";
            case 'Y': /* Year */ return iDate.getFullYear();
            case 'YY': /* Year */ return String(iDate.getFullYear()).substring(2);
            case 'YYYY': /* Year */ return iDate.getFullYear();
            case 'M': /* Month in year */ return iDate.getMonth() + 1;
            case 'MM': /* Month in year */ return String(iDate.getMonth() + 1).padStart(2, '0');
            case 'd': /* Day in a month */ return iDate.getDate();
            case 'dd': /* Day in a month */ return String(iDate.getDate()).padStart(2, '0');
            /* Time */
            case 'h': /* Hour in am/pm */ return iDate.getTime();
            case 'H': /* Hour in day */ return this.calcHour(mtime);
            case 'HH': /* Hour in day */ return this.calcHour(mtime).padStart(2, '0');
            case 'm': /* Minute in hour */ return this.calcMin(mtime);
            case 'mm': /* Minute in hour */ return this.calcMin(mtime).padStart(2, '0');
            case 's': /* second in minute */ return this.calcSec(mtime);
            case 'ss': /* second in minute */ return this.calcSec(mtime).padStart(2, '0');
            case 'S': /* Millisecond */ return iDate.getTime();
            case 'E': /* Day in week */ break;
            case 'D': /* Day in year */ break;
            case 'F': /* Days of week in month */ break;
            case 'w': /* Week in year */ break;
            case 'W': /* Week in month */ break;
            case 'a': /* AM/PM marker */ break;
            case 'k': /* Hour in day  */ break;
            case 'K': /* Hour in am/pm */ break;
            case 'z': /* TimeZone */ break;
            case 'Z': /* TimeZone */ break;
            case 'X': /* TimeZone */ break;
            default:
                return iFormat;
        }
    }
    translateDate(iDate, iFormat) {
        let lastStr = "";
        let resultStr = "";
        if (isNaN(iDate.valueOf())) {
            return '';
        }
        ;
        [...iFormat].forEach((c, idx) => {
            if (lastStr[lastStr.length - 1] == c) {
                lastStr += c;
            }
            else {
                resultStr += this.date2Format(iDate, lastStr);
                lastStr = "";
                lastStr += c;
            }
            if (idx === [...iFormat].length - 1)
                resultStr += this.date2Format(iDate, lastStr);
        });
        return resultStr;
    }
    formatDate(iDate) {
        let retVal = '';
        try {
            if (!(iDate instanceof Date)) {
                if (iDate.length == 6) {
                    iDate = new Date(iDate.substring(0, 2) + '-' + iDate.substring(2, 4) + '-' + iDate.substring(4));
                }
                else if (iDate.length == 8) {
                    iDate = new Date(iDate.substring(0, 4) + '-' + iDate.substring(4, 6) + '-' + iDate.substring(6));
                }
                else {
                    //error state throw new VomitException('Lårtykke stråler');
                    return '';
                }
            }
            // if(this.dateOptions){
            //     retVal = new Intl.DateTimeFormat(this.dateLang, this.dateOptions).format(iDate);
            // } else {
            //     retVal = `${iDate.getFullYear()}-${String(iDate.getMonth()+1).padStart(2, '0')}-${iDate.getDate()}`
            // }
            retVal = this.translateDate(iDate, this.dateFormat_);
        }
        catch (_a) { }
        return retVal;
    }
    formatDateTime(iDateTime) {
        // let retVal: string = '';
        // retVal = this.translateDate(iDateTime, this.dateTimeFormat_);
        // try{
        //     let then = new Date(iDateTime.getFullYear(), iDateTime.getMonth(), iDateTime.getDate(), 0, 0, 0);
        //     retVal = `${this.formatDate(iDateTime)} - ${this.formatTime((iDateTime.getTime() - then.getTime())/1000)}`
        // } catch{}    
        return this.translateDate(iDateTime, this.dateTimeFormat_);
    }
    hasUpdated() {
        let res = { updated: false };
        if (this.hasData_) {
            res.updated = true;
        }
        else {
            res.promise = this.getData();
        }
        return res;
    }
    //Progress / API communication
    setData() {
        this.options_ = {
            systemId: PIC.systemId,
            postBody: {
                'mode': 'set',
                'data': {
                    'userLang': this.userLang,
                    'dateLang': this.dateLang_,
                    'dateOptions': this.dateOptions_,
                    'timeOptions': this.timeOptions_,
                    'datetimeFormat': this.dateTimeFormat_,
                    'dateFormat': this.dateFormat_,
                    'timeFormat': this.timeFormat_,
                    'currencyLang': this.currencyLang_,
                    'currency': this.currency_,
                    'numberLang': this.numberLang_,
                    'minMaxDigits': this.minMaxDigits_,
                    'isNavDrawerPinned': this.isNavDrawerPinned_,
                    'theme': this.theme_,
                    'sendError': this.sendError_
                }
            }
        };
        fetchApiData('incl/settings', this.options_)
            .then(res => {
            PIC.getInstance.msg('set has returned', res);
            this.options_.postBody = {};
        });
    }
    getData() {
        this.options_ = {
            systemId: PIC.systemId,
            postBody: {
                'mode': 'get'
            }
        };
        return fetchApiData('incl/settings', this.options_)
            .then(res => {
            PIC.getInstance.msg('get has returned', res);
            this.userLang = res.userLang ? res.userLang : this.userLang;
            this.dateLang_ = res.dateLang ? res.dateLang : this.dateLang_;
            this.dateOptions_ = res.dateOptions ? res.dateOptions : this.dateOptions_;
            this.timeOptions_ = res.timeOptions ? res.timeOptions : this.timeOptions_;
            this.dateFormat_ = res.dateFormat ? res.dateFormat : this.dateFormat_;
            this.timeFormat_ = res.timeFormat ? res.timeFormat : this.timeFormat_;
            this.dateTimeFormat_ = res.datetimeFormat ? res.datetimeFormat : this.dateTimeFormat_;
            this.currencyLang_ = res.currencyLang ? res.currencyLang : this.currencyLang_;
            this.currency_ = res.currency ? res.currency : this.currency_;
            this.numberLang_ = res.numberLang ? res.numberLang : this.numberLang_;
            this.minMaxDigits_ = res.minMaxDigits ? res.minMaxDigits : this.minMaxDigits_;
            this.isNavDrawerPinned_ = res.isNavDrawerPinned ? res.isNavDrawerPinned : this.isNavDrawerPinned;
            this.theme_ = res.theme ? res.theme : this.theme_;
            this.applyTheme();
            this.sendError_ = res.sendError ? res.sendError : this.sendError_;
            this.options_.postBody = {};
            this.hasData_ = true;
        }).catch(() => PIC.getInstance.msg('API returned empty'));
    }
}
//# sourceMappingURL=GlobUserConfig.js.map